import { apiPost, ApiError } from '.';

/**
 * Запрос серий продуктов
 */
const apiMapSettings = async () => {
  const { err, errmsg, data } = await apiPost('/map/settings', {});
  if (err !== 0) throw ApiError(err, errmsg);
  return data;
};
export default apiMapSettings;
